import { ApiRequest } from 'framework/api';
import { AuthenticationRecord, AuthenticationType } from 'areas/administration/authentication/types';

export type GetAuthenticationArgs = {
	accountId: string;
	id: string;
	update: boolean;
};

export type GetAuthenticationTypesArgs = {
	types?: string[];
};

export type AuthenticationTypeInfo = {
	authenticationType: AuthenticationType;
	authenticationTypeText: string;
};

export type GetAuthenticationsByNameArgs = {
	accountId: string;
	name: string;
};

export type SaveAuthenticationPayload = Partial<AuthenticationRecord> & {
	id: string | null;
	accountId: string;
};

export type OAuthValidationResponse = {
	hasRefreshToken?: boolean;
	userCode?: string;
	userCodeExpires?: number;
	verificationURL?: string;
	message?: string;
	apiKey?: string;
	apiSecret?: string;
	authServer?: string;
	tokenServer?: string;
	scope?: string;
};

export function getAuthentication({ accountId, id, update }: GetAuthenticationArgs) {
	return new ApiRequest<AuthenticationRecord & OAuthValidationResponse>({
		url: `authentications/${id}/?update=${update}`,
		accountBased: true,
		accountId,
	});
}

export function getAuthenticationTypes({ types }: GetAuthenticationTypesArgs) {
	const query = (types ?? []).map((type) => 'types=' + encodeURIComponent(type)).join('&');
	return new ApiRequest<AuthenticationTypeInfo[]>({
		url: `accounts/authentications/?${query}`,
	});
}

export function getAuthenticationsByName({ accountId, name }: GetAuthenticationsByNameArgs) {
	return new ApiRequest<AuthenticationRecord[]>({
		url: `authentications/list?name=${encodeURIComponent(name)}`,
		accountBased: true,
		accountId,
	});
}

export function saveAuthentication(payload: SaveAuthenticationPayload) {
	return new ApiRequest<AuthenticationRecord>({
		url: 'accounts/authentications/',
		payload,
	});
}

export function validateAuthentication(payload: SaveAuthenticationPayload) {
	return new ApiRequest<OAuthValidationResponse>({
		url: 'accounts/authentications/validateAuthentication',
		payload,
		suppressErrorMessage: true,
	});
}
